import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.x2};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;
